import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { UpaUserProfileDataModel, Validation } from '../../../Core/models';
import { CommonService, EmailValidationService, SwProcessStateService } from '../../../Core/Services';

@Component({
  selector: '[app-email]',
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.css']
})
export class EmailComponent implements OnInit {

  constructor(private swProcessStateService: SwProcessStateService, private emailValidationService: EmailValidationService,
    private commonService: CommonService) { }

  @Output() onSubmit: EventEmitter<string> = new EventEmitter<string>();

  public errorClass = '';
  public error: Validation = new Validation();
  public flag: number;
  public email: string;
  public Issectionwise: boolean

  isReadOnly: boolean = false;
  @Input() isUpaEnable: boolean = false;
  @Input() isUserLoggedIn: boolean = false;
  @Input() upaUserData: UpaUserProfileDataModel;

  ngOnInit() {
    this.emailValidationService.emailValid$.subscribe({
      next: (error) => {
        this.error.isInValid = error.isInValid;
        this.error.errorCss = error.errorCss
      }
    })

    this.swProcessStateService.isSW$.subscribe(isSw => {
      if (isSw) {
        this.Issectionwise = true;
        this.swEmail();
      }
    })

  }

  ngOnChanges() {
    this.swProcessStateService.isSW$.subscribe(isSw => {
      if (this.isUpaEnable && this.isUserLoggedIn && !isSw) {
        this.email = this.upaUserData.email;
        this.isReadOnly = true;
        this.submitAnswer(this.email);
      }
    })
  }

  swEmail() {
    this.swProcessStateService.swProcessModel$.subscribe(swInput => {
      this.email = this.commonService.maskEmail(swInput?.emailAddress);
    })
  }

  submitAnswer(email: string) {
    this.onSubmit.emit(email)
  }

  onClick($event) {
    if (this.Issectionwise && $event.target.value == this.email) {
      this.email = "";
      this.onSubmit.emit(this.email);
    }
  }

  
}
